__turbopack_context__.v({
  "container": "RhZwZW_container",
});
